import React from "react";

const Header = () => {
    return (
        <>
            <div className="d-flex text-white p-3 tx-34 align-content-lg-start" style={{background: '#430323'}}>
                予約状況
            </div>
        </>
    );
};

export default Header;